module.exports = __webpack_public_path__ + "static/media/3-3.15347011.png";